import React from 'react';
import Hex from '../../map/Hex.js';
import Straight1 from './variant/Straight1.js';
import Straight2 from './variant/Straight2.js';
import Turn1 from './variant/Turn1.js';
import { createListOfAllVariants, createVariantGroups, } from '../utils/withRotation.js';
import HardTurn1 from './variant/HardTurn1.js';
import Fork1 from './variant/Fork1.js';
import { TERRAIN_COLOR_PLAIN } from '../colors.js';
const basicVariants = {
    default: Straight1,
    straight1: Straight1,
    straight2: Straight2,
    turn1: Turn1,
    hardTurn1: HardTurn1,
    fork1: Fork1,
};
export const variantGroups = createVariantGroups(Object.keys(basicVariants));
const variants = createListOfAllVariants(basicVariants);
function RiverHex(props) {
    const style = (props && props.style) || {};
    const Variant = variants[props.graphicalVariant ?? 'default'];
    return (React.createElement(Hex, { ...props, style: {
            ...style,
            fill: TERRAIN_COLOR_PLAIN,
        } },
        React.createElement(Variant, { ...props }),
        props.children));
}
export const graphicalVariants = Object.keys(variants);
export default RiverHex;
